
export default function Pricing() {
  const plans = [
    {
      name: '개인',
      badge: '개인',
      price: '3,300만원',
      members: '기명 1인',
      yearlyFee: '120만원/년',
      benefit: '600만원 혜택',
      features: [
        '주중 6회 / 주말 24회',
        '그린피 50% 할인',
        '5년 후 100% 반환',
        '입회비 36,500,000원 시 월 1회 위임 혜택'
      ],
      highlighted: false
    },
    {
      name: '개인 1+1',
      badge: '개인 1+1',
      price: '6,300만원',
      members: '기명 1인 + 무기명 1인',
      yearlyFee: '230만원/년',
      benefit: '1,150만원 혜택',
      features: [
        '주중 6회 / 주말 24회',
        '그린피 50% 할인',
        '5년 후 100% 반환',
        '무기명 1인 추가 혜택'
      ],
      highlighted: false
    },
    {
      name: '법인',
      badge: '추천',
      price: '1.29억원',
      members: '무기명 4인',
      yearlyFee: '450만원/년',
      benefit: '2,250만원 혜택',
      features: [
        '주중 6회 / 주말 24회',
        '그린피 50% 할인',
        '5년 후 100% 반환',
        '무기명 4인 혜택'
      ],
      highlighted: true
    },
    {
      name: '법인 고급형',
      badge: '법인 고급형',
      price: '2.85억원',
      members: '무기명 4인',
      yearlyFee: '700만원/년',
      benefit: '3,500만원 혜택',
      features: [
        '주중 6회 / 주말 24회',
        '그린피 50% 할인',
        '5년 후 100% 반환',
        '무기명 4인 혜택'
      ],
      highlighted: false
    },
    {
      name: '법인 프리미엄',
      badge: '법인 프리미엄',
      price: '5.19억원',
      members: '무기명 4인',
      yearlyFee: '1,000만원/년',
      benefit: '5,000만원 혜택',
      features: [
        '주중 12회 / 주말 36회',
        '그린피 전액 무료',
        '5년 후 100% 반환',
        '무기명 4인 혜택'
      ],
      highlighted: false,
      premium: true
    }
  ];

  return (
    <section id="pricing" className="py-14 md:py-20 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-10 md:mb-16">
          <h2 className="text-2xl sm:text-3xl md:text-5xl font-bold text-gray-900 mb-3 md:mb-4 leading-tight">
            귀하의 골프 스타일에 최적화된 라인업
          </h2>
          <p className="text-sm sm:text-base md:text-xl text-gray-600 max-w-3xl mx-auto">
            선착순 50구좌 한정 특별 혜택 - 5년간 연회비 전액 면제
          </p>
        </div>

        {/* 모바일: 세로 스크롤 / 태블릿: 2열 / 데스크탑: 5열 */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-6 mb-8 md:mb-12">
          {plans.map((plan, index) => (
            <div
              key={index}
              className={`relative rounded-2xl p-5 md:p-6 shadow-xl transition-all flex flex-col ${
                plan.highlighted
                  ? 'bg-gradient-to-br from-blue-600 to-blue-800 text-white lg:scale-105 border-4 border-blue-400'
                  : plan.premium
                  ? 'bg-white border-2 border-amber-400'
                  : 'bg-white border-2 border-gray-200 hover:border-blue-500'
              }`}
            >
              {plan.highlighted && (
                <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-amber-400 text-gray-900 px-4 py-1 rounded-full text-xs font-bold whitespace-nowrap">
                  추천
                </div>
              )}

              <div className="text-center mb-3 md:mb-4">
                <span className={`inline-block text-xs font-bold px-3 py-1 rounded-full mb-2 ${
                  plan.highlighted
                    ? 'bg-white/20 text-white'
                    : plan.premium
                    ? 'bg-amber-50 text-amber-700'
                    : 'bg-blue-50 text-blue-700'
                }`}>
                  {plan.badge}
                </span>
                <h3 className={`text-base md:text-xl font-bold mb-1 ${plan.highlighted ? 'text-white' : 'text-gray-900'}`}>
                  {plan.name}
                </h3>
                <div className={`text-2xl md:text-3xl font-bold mb-1 ${
                  plan.highlighted
                    ? 'text-white'
                    : plan.premium
                    ? 'text-amber-600'
                    : 'text-blue-600'
                }`}>
                  {plan.price}
                </div>
                <p className={`text-xs ${plan.highlighted ? 'text-white/80' : 'text-gray-500'}`}>
                  {plan.members}
                </p>
              </div>

              <div className={`rounded-lg px-3 py-2 mb-3 md:mb-4 text-center ${
                plan.highlighted
                  ? 'bg-white/20 border border-white/30'
                  : plan.premium
                  ? 'bg-amber-50 border border-amber-200'
                  : 'bg-green-50 border border-green-200'
              }`}>
                <div className={`text-xs line-through ${plan.highlighted ? 'text-white/60' : 'text-gray-500'}`}>
                  연회비 {plan.yearlyFee}
                </div>
                <div className={`text-xs md:text-sm font-bold ${
                  plan.highlighted
                    ? 'text-amber-300'
                    : plan.premium
                    ? 'text-amber-600'
                    : 'text-green-600'
                }`}>
                  ✓ 5년간 연회비 면제
                </div>
                <div className={`text-xs ${
                  plan.highlighted
                    ? 'text-amber-200'
                    : plan.premium
                    ? 'text-amber-500'
                    : 'text-green-500'
                }`}>
                  ({plan.benefit})
                </div>
              </div>

              <ul className="space-y-2 mb-4 md:mb-5 flex-1">
                {plan.features.map((feature, idx) => (
                  <li key={idx} className="flex items-start text-xs md:text-sm">
                    <i className={`ri-check-line mr-2 mt-0.5 flex-shrink-0 ${
                      plan.highlighted
                        ? 'text-white'
                        : plan.premium
                        ? 'text-amber-600'
                        : 'text-blue-600'
                    }`}></i>
                    <span className={plan.highlighted ? 'text-white' : ''}>{feature}</span>
                  </li>
                ))}
              </ul>

              <a
                href="#signup"
                className={`block w-full text-center py-2.5 md:py-3 rounded-lg text-sm font-semibold transition-colors whitespace-nowrap cursor-pointer ${
                  plan.highlighted
                    ? 'bg-white text-blue-600 hover:bg-gray-50'
                    : plan.premium
                    ? 'bg-amber-600 text-white hover:bg-amber-700'
                    : 'bg-blue-600 text-white hover:bg-blue-700'
                }`}
              >
                상담 신청
              </a>
            </div>
          ))}
        </div>

        <div className="bg-blue-50 rounded-xl p-4 md:p-6 text-center">
          <p className="text-gray-700 text-xs md:text-sm font-medium">
            ※ 선착순 50구좌 한정 프로모션 — <strong className="text-blue-600">5년간 연회비 전액 면제</strong> (최대 5,000만원 혜택)
          </p>
          <p className="text-gray-500 text-xs mt-2">
            ※ 개인(기명 1인) 상품의 경우, 입회비(36,500,000원) 가입 시 월 1회 위임 혜택 추가
          </p>
        </div>
      </div>
    </section>
  );
}
